import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFolderPlus,
    faFileLines,
} from '@fortawesome/free-solid-svg-icons';

const NoTemplateView = () => {
    return (
        <div className='bg-backgrounds-slate w-full h-full rounded-xl flex items-center justify-center'>
            <div className='w-full h-full flex flex-col items-center'>
                <div className='flex h-4/6 w-full items-center justify-center text-texts-secondary300'>
                    <div className='flex flex-col items-center justify-center m-[3vw]'>
                        <FontAwesomeIcon
                            icon={faFileLines}
                            className='w-[8vw] h-[8vw] mb-2 drop-shadow text-icons-primary100'
                        />
                        <div>No Templates Available</div>
                    </div>
                </div>
                <div className='flex items-center justify-center text-texts-secondary300 text-xl pt-10'>
                    <FontAwesomeIcon
                        icon={faFolderPlus}
                        className='mr-3 text-icons-primary'
                    />
                    <div>
                        Click the Create New Template button in the sidebar to get started
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoTemplateView;
